import React, { useState } from 'react';
import Note from 'components/Note';
import AddNote from 'components/AddNote';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';
import { useSwipeable } from 'react-swipeable';
import { NotesContainer, NavigatorContainer, Navigator } from './styles';

const Notes = ({
  notes=[],
  note,
  setNote,
  onAddNote,
  onRemoveNote,
  pageSize,
  addNoteHidden,
  loading,
  disabled
}) => {

  const [pageNumber, setPageNumber] = useState(1)
  const pageCount = Math.ceil(notes?.length/pageSize)
  const sortedNotes = notes? [...notes].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) : []

  const paginate = (array, page_size, page_number) => {
    const newArray = [...array]
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return newArray.slice((page_number - 1) * page_size, page_number * page_size);
  }

  const previousPage = () => {
    if(pageNumber > 1) {
      setPageNumber((pageNumber) => pageNumber-1)
    }
  }

  const nextPage = () => {
    if(pageNumber < pageCount) {
      setPageNumber((pageNumber) => pageNumber+1)
    }
  }

  const handles = useSwipeable({
    onSwipedLeft: () => nextPage(),
    onSwipedRight: () => previousPage(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  })

  return (
    <>
      {
        notes.length>pageSize ? 
          (
            <NavigatorContainer>
              <Navigator
                disabled={pageNumber<=1} 
                onClick={previousPage}
              >
                {'<'} Back
              </Navigator>
              <Navigator
                disabled={pageNumber>= notes.length/pageSize}
                onClick={nextPage}
              >
                Next {'>'}
              </Navigator>
              {/* <Swiper
                disabled={pageNumber<=1}
              >
                {'<'}
              </Swiper>
              <Swiper>
                SWIPE
              </Swiper>
              <Swiper
                disabled={pageNumber>= notes.length/pageSize}
              >
                {'>'}
              </Swiper> */}
            </NavigatorContainer>            
          ): null 
      }
      <NotesContainer {...handles}>
        {
          sortedNotes.length
            ? paginate(sortedNotes, pageSize, pageNumber).map((note) => {
              return (
                <Note
                  key={note.noteId || note.createdAt}
                  date={moment(note.createdAt).tz(TIME_ZONE).format('MMM Do YYYY h:mm A')}
                  author={note.createdBy?.fullName}
                  description={note.notes}
                  onRemove={() => onRemoveNote(note.noteId || note.createdAt)}
                  disabled={disabled}
                  unsynced={note.unsynced}
                />
              )
            })
            : null
        }
      </NotesContainer>
      {
        !addNoteHidden? 
          <AddNote
            onChangeNote={setNote}
            onAddNote={onAddNote}
            loading={loading}
            note={note}
          />: null
      }
    </>
  );
};

export default Notes;
